import { queryOptions } from '@tanstack/react-query';

import { api } from '~/lib/api';
import { i18n } from '~/lib/i18n';

export function atsConfigQueryOptions(orgId: string) {
  return queryOptions({
    queryKey: ['integrations', 'config', orgId] as const,
    queryFn: async () => {
      const res = await api.api.org[':orgId'].integrations.$get({ param: { orgId } });
      if (!res.ok) throw new Error(i18n.t('errors.unexpected'));
      return res.json();
    }
  });
}
